"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiveCardStudOptions = void 0;
/** FiveCardStudOptions.ts
 *
 * Game Options for FiveCardStud.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.FiveCardStudOptions = {
    versions: [
        {
            title: "5 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.FIVE_CARD,
            default: true,
            flavor: 5,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [
        defaultOptions_1.optionNoneDefault,
        Object.assign(Object.assign({}, defaultOptions_1.optionRollYourOwn), { description: "Roll Your Own (First card)" }),
    ],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHole,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=FiveCardStudOptions.js.map